import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form", {
    attrs: {
      layout: "inline",
      form: _vm.form
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("模板名称")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("模板名称"),
      allowClear: ""
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("页面类型")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "180px"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("页面类型"),
      allowClear: ""
    },
    model: {
      value: _vm.form.pageType,
      callback: function ($$v) {
        _vm.$set(_vm.form, "pageType", $$v);
      },
      expression: "form.pageType"
    }
  }, _vm._l(_vm.pageTypeList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.key
      }
    }, [_vm._v(_vm._s(_vm.$t(item.value)))]);
  }), 1)], 1), _c("a-form-item", [_c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: _vm.searchFun
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("查询")) + " ")]), _vm.isAuth("home.DynamicControlsStore") ? _c("a-button", {
    attrs: {
      type: "add",
      icon: "plus"
    },
    on: {
      click: function ($event) {
        return _vm.handleEdit(null);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("新增模板")) + " ")]) : _vm._e()], 1)], 1), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.data,
      pagination: _vm.pagination,
      rowKey: "id"
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function (text, record, index) {
        return [_vm._v(" " + _vm._s(index + 1) + " ")];
      }
    }, {
      key: "pageTypeName",
      fn: function (text) {
        return [_vm._v(_vm._s(_vm.$t(text)))];
      }
    }, {
      key: "status",
      fn: function (text, record) {
        return [_c("a-switch", {
          attrs: {
            checked: text == 1 ? true : false
          },
          on: {
            click: function ($event) {
              return _vm.checkedFun(record);
            }
          }
        })];
      }
    }, {
      key: "action",
      fn: function (text, record) {
        return [_vm.isAuth("home.DynamicControlsEdit") ? _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            type: "edit",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.handleEdit(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("编辑")))]) : _vm._e(), _vm.isAuth("home.DynamicControlsSetConfig") ? _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            type: "primary2",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.$router.push({
                name: "templateConfiguration",
                params: {
                  id: record.id,
                  type: record.pageType
                }
              });
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("配置模板")))]) : _vm._e(), _vm.isAuth("home.DynamicControlsPreview") && record.status == 1 ? _c("a-button", {
          attrs: {
            type: "copy",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.handlePreview(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("预览")))]) : _vm._e()];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _vm.templateShow ? _c("template-model", {
    ref: "templateRef",
    on: {
      cancel: function ($event) {
        _vm.templateShow = false;
      },
      save: _vm.searchFun
    }
  }) : _vm._e(), _vm.informationShow ? _c("information-model", {
    ref: "informationRef",
    on: {
      cancel: function ($event) {
        _vm.informationShow = false;
      }
    }
  }) : _vm._e(), _vm.templatPereviewShow ? _c("preview-model", {
    ref: "templatPereviewRef",
    on: {
      cancel: function ($event) {
        _vm.templatPereviewShow = false;
      }
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };